import { PlayerStates } from '../../model/states/PlayerState'
import type { PlayerState } from '../../model/states/PlayerState.types'

export const canReceiveChips = (playerState: PlayerState) => {
  return (
    PlayerStates.isInPlay(playerState) ||
    PlayerStates.isFolded(playerState) ||
    PlayerStates.isAllIn(playerState) ||
    PlayerStates.isOut(playerState)
  )
}
